export default{
	method: 'post',
    // 基础url前缀
    baseURL: 'http://www.nekupet.com/',
    // 请求接口目录
    actionURL:'',
    // 请求头信息
    headers: {
      'Content-Type':'application/json;charset=UTF-8'
    },
    // 参数
    data: {},
    // 设置超时时间
    timeout: 10000,
    // 携带凭证
    withCredentials: false,
    // 返回数据类型
    responseType: 'json',
    //
    TweenTime:0.5,


    

}